import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {message: String}

  connect() {
    M.toast({html: this.messageValue})
  }
}
